import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Component to display validation errors for a question
 * Shows errors when user selections violate validation rules
 * 
 * @param {Object} props - Component props
 * @param {Array} props.errors - Array of validation error objects
 * @param {Object} props.colors - Color scheme for styling
 * @returns {JSX.Element|null} Error display component or null if no errors
 */
const ValidationErrorDisplay = ({ errors = [], colors = {} }) => {
  const { t } = useTranslation();

  // Don't render if no errors
  if (!errors || !Array.isArray(errors) || errors.length === 0) {
    return null;
  }

  return (
    <div className="validation-errors mt-2">
      {errors.map((error, index) => (
        <div 
          key={index}
          className="alert alert-danger d-flex align-items-start py-2"
          role="alert"
          style={{
            backgroundColor: `${colors?.danger || '#dc3545'}10`,
            border: `1px solid ${colors?.danger || '#dc3545'}40`,
            borderLeft: `4px solid ${colors?.danger || '#dc3545'}`
          }}
        >
          <div className="me-2 mt-1">
            <i 
              className="fa-solid fa-exclamation-triangle"
              style={{ color: colors?.danger || '#dc3545' }}
            ></i>
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold small mb-1" style={{ color: colors?.danger || '#dc3545' }}>
              {t('validationError', { ns: 'labels', defaultValue: 'Errore di Validazione' })}
            </div>
            <div className="small">
              {error.rule_description || error.message}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationErrorDisplay;
